import { render } from "./IconArrow.vue?vue&type=template&id=5477960b"
import script from "./IconArrow.vue?vue&type=script&lang=js"
export * from "./IconArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__